import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { LoadingService } from "../../services/loading.service";
import { NgProgress, NgProgressRef } from "@ngx-progressbar/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-digital-layout",
  templateUrl: "./digital-layout.component.html",
  styleUrls: ["./digital-layout.component.scss"],
})
export class DigitalLayoutComponent implements OnInit {
  progressRef: NgProgressRef;
  showLayout = true;

  constructor(
    private cdr: ChangeDetectorRef,
    private progress: NgProgress,
    private loadingService: LoadingService,
    private router: Router
  ) {
    this.loadingService.getLoading().subscribe(isLoading => {
      if (this.progressRef) {
        if (isLoading) {
          this.progressRef.start();
          this.cdr.detectChanges();
        } else {
          this.progressRef.complete();
          this.cdr.detectChanges();
        }
      }
    });

    // Kiểm tra route để ẩn layout cho preview
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      // Ẩn layout nếu URL chứa /preview
      this.showLayout = !event.url.includes("/preview");
      this.cdr.detectChanges();
    });
  }

  ngOnInit() {
    this.progressRef = this.progress.ref("progressBar");

    // Kiểm tra ban đầu
    this.showLayout = !this.router.url.includes("/preview");
  }
}
